// import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
//import { saveAs } from '@progress/kendo-file-saver';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';

// export async function generateCertificate(certificate,name) {

//   const bytes = await fetch(
//     'https://assets.learntube.ai/files/TEST/LT_Template2.pdf?ik-sdk-version=javascript-1.4.3&updatedAt=1652118552508'
//   ).then((res) => res.arrayBuffer());

//   const pdfDoc = await PDFDocument.load(bytes);

//   const TimesRoman1 = await pdfDoc.embedFont(StandardFonts.TimesRoman);
//   const TimesRoman2 = await pdfDoc.embedFont(StandardFonts.TimesRomanItalic);

//   const text1 = name;

//   const text2 = `for successfully completing ${
//     certificate?.certificate_name
//   } on ${new Date(certificate?.created_at).toLocaleDateString()}.`;

//   const text3 = `${certificate?.unique_certificate_id}`;

//   const textSize1 = 45;
//   const textSize2 = 20;
//   const textWidth1 = TimesRoman1.widthOfTextAtSize(text1, textSize1);
//   const textWidth2 = TimesRoman2.widthOfTextAtSize(text2, textSize2);
//   const textWidth3 = TimesRoman2.widthOfTextAtSize(text3, textSize2);

//   const pages = pdfDoc.getPages();

//   pages[0].drawText(text1, {
//     x: pages[0].getWidth() / 2 - textWidth1 / 2,
//     y: 330,
//     size: textSize1,
//     font: TimesRoman1,
//     color: rgb(1, 1, 1),
//   });
//   pages[0].drawText(text2, {
//     x: pages[0].getWidth() / 2 - textWidth2 / 2,
//     y: 285,
//     size: textSize2,
//     font: TimesRoman2,
//     color: rgb(1, 1, 1),
//   });
//   pages[0].drawText(text3, {
//     x: pages[0].getWidth() / 2 - textWidth3 / 2,
//     y: 110,
//     size: textSize2,
//     font: TimesRoman1,
//     color: rgb(1, 1, 1),
//   });

//   const pdfBytes = await pdfDoc.save();
//   saveAs(new Blob([pdfBytes]), `${text1}-certificate.pdf`);
// }
export async function generateCertificate(testData) {
  console.log({testData});
  const blob = new Blob([testData], {
    type: 'image/jpeg',
  });
 
  var urlCreator = window.URL || window.webkitURL;
  var imageUrl = urlCreator.createObjectURL( blob );
  
 saveAs(blob, 'Certificate.jpeg');
 
  //For mobile app
  // (() => {
  //   window?.ReactNativeWebView?.postMessage(
  //     JSON.stringify({
  //       type: 'download',
  //       url: '',
  //     }),
  //   );
  // })();
}

export async function getLinkFromBuffer(testData){
  try{
  console.log({testData});
  const blob = new Blob([testData], {
    type: 'image/jpeg',
  });
 
  var urlCreator = window.URL || window.webkitURL;
  var imageUrl = urlCreator.createObjectURL( blob )
  
  return imageUrl;
}
catch(err){
  console.log(err);
}

}

export async function downloadCertificate(link) {
  const bytes = await fetch(link, {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate'
    }
  })
    .then((res) => {toast.success("Certificate downloaded successfully.");  return res.arrayBuffer()})
    .catch((err) => {toast.error("Download failed. Please try again."); console.log(err);});

 
    console.log("bytes",bytes ,link);
    if(bytes){
    saveAs(new Blob([bytes]), `Certificate.jpg`);
    }
  

  (() => {
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: 'download',
        url: link,
      }),
    );
  })();
}


export function cleanSkillName(skillName) {
    if (typeof skillName !== 'string') return ''
    return skillName.replace(/\s*\([^)]*\)/g, '').trim()
}